import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { AggregateTransformation } from 'app/model/dataflow/aggregatetransformation';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AggregateTransformation),
    asynchronous: true
})
export class AggregateTransformationAdapter extends TransformationAdapter<AggregateTransformation> {
    public async getDslScript(aggregatorTransformation: AggregateTransformation): Promise<string> {
        const columnConditions = await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
            this.context.contextData,
            aggregatorTransformation.expressionColumns,
            aggregatorTransformation
        );
        const transientAssignments = await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
            this.context.contextData,
            aggregatorTransformation.transientExpressionColumns,
            aggregatorTransformation
        );
        const groupBy =
            aggregatorTransformation.groupByColumns.length > 0
                ? ExpressionBasedColumnVisitorAdapterUtils.getGroupByColumnsDsl(aggregatorTransformation)
                : '';
        const partition = TransformationAdapter.getPartitionDslScript(aggregatorTransformation);

        const knownProps =
            `${groupBy}${groupBy && (columnConditions || partition) ? ',\n\t' : ''}${columnConditions}` +
            `${transientAssignments ? ',\n\t' : ''}${transientAssignments}` +
            `${columnConditions && partition ? ',\n\t' : ''}${partition}`;
        const unknownProps = this._getUnknownProps(aggregatorTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(aggregatorTransformation)} ${AggregateTransformation.MODEL.name}` +
            `(${transformationData}) ${FLOW} ${this._getOutputStreams(aggregatorTransformation)}`
        );
    }
}
